const classes = {
  wrapper: 'flex flex-col md:flex-row gap-10',
  map: 'flex justify-center w-full md:w-6/12',
  content: 'flex flex-col gap-6 w-full md:w-6/12',
};

export default classes;
